<template>
  <v-container fluid fill-height align-start ma-0 pa-2>
    <v-row no-gutters>
      <v-col cols="12" sm="12" lg="12" class="pa-2 pb-0">
        <i-card-top
          class="d-md-flex"
          headerTitle
          :useBtnList="buttonUseList"
          @btnSearch="btnSearch"
          @btnPrint="btnPrint"
        >
          <template v-slot:body>
            <v-layout>
              <v-row no-gutters class="pa-0">
                <v-col cols="12" md="4">
                  <v-select
                    :menu-props="{ offsetY: true }"
                    color="primary"
                    class="required mx-1 rounded-0 pt-2 px-2 px-md-0 pl-md-2"
                    item-text="minorNm"
                    item-value="minorCd"
                    :prepend-inner-icon="$t('$search')"
                    :items="selectRiskAssRoleList"
                    label="위험성평가 조직역할"
                    dense
                    outlined
                    v-model="riskAssRole"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3" class="pt-2 px-2 px-md-0">
                  <v-text-field
                    v-model="korNm"
                    label="성명"
                    class="mx-1 rounded-0"
                    dense
                    outlined
                    hide-details="auto"
                    :prepend-inner-icon="$t('$search')"
                    @keydown.enter="btnSearch()"
                    clearable
                  />
                </v-col>
                <v-radio-group v-model="delYn" row class="pl-4 pl-md-2 pt-2 pt-md-3">
                  <v-radio
                    color="radio"
                    v-for="(item, value) in delYnList"
                    :key="value"
                    :label="item.text"
                    :v-model="item.value"
                  ></v-radio>
                </v-radio-group>
              </v-row>
            </v-layout>
          </template>
        </i-card-top>
      </v-col>
      <v-col cols="12" sm="12" lg="12" class="pa-2 pt-0">
        <i-card-vertical headerTitle="인원관리">
          <template v-slot:body>
            <v-layout column layout-col-height5>
              <v-col cols="12" md="12" class="row pa-0">
                <v-col cols="12" lg="12" class="pa-0">
                  <DxDataGrid
                    id="hrDataGrid"
                    class="layout-col-height00"
                    width="100%"
                    :ref="dxDataGridRef"
                    :data-source="gridMain"
                    :remote-operations="false"
                    :hover-state-enabled="true"
                    :allow-column-resizing="true"
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true"
                    :column-auto-width="true"
                    :show-borders="true"
                    :show-row-lines="true"
                    :focused-row-enabled="true"
                    :selection="{ mode: 'single' }"
                    key-expr="id"
                    @editor-preparing="onEditorPreparing"
                  >
                    <DxEditing
                      mode="batch"
                      :allow-updating="true"
                      :select-text-on-edit-start="true"
                    />

                    <DxSelection
                      select-all-mode="allMode"
                      show-check-boxes-mode="always"
                      mode="multiple"
                    />

                    <DxColumn data-field="compId" data-type="string" :visible="false"></DxColumn>

                    <DxColumn data-field="esgHrNo" data-type="string" :visible="false"></DxColumn>

                    <DxColumn
                      data-field="korNm"
                      caption="성명"
                      width="100px"
                      data-type="string"
                      alignment="center"
                      css-class="devest-grid-header-require"
                    ></DxColumn>

                    <DxColumn
                      data-field="engNm"
                      caption="영문명"
                      width="100px"
                      data-type="string"
                      alignment="center"
                    ></DxColumn>

                    <DxColumn
                      data-field="sexDiv"
                      caption="성별"
                      width="100px"
                      data-type="string"
                      alignment="center"
                    >
                      <DxLookup :data-source="sexDivList" />
                    </DxColumn>

                    <DxColumn
                      data-field="birthDt"
                      caption="생년월일"
                      width="100px"
                      data-type="date"
                      alignment="center"
                      format="yyyy.MM.dd"
                    ></DxColumn>

                    <DxColumn
                      data-field="jbrp"
                      caption="직책/직위"
                      width="100px"
                      data-type="string"
                      alignment="center"
                    >
                      <DxLookup
                        :data-source="jbrpList"
                        value-expr="minorCd"
                        display-expr="minorNm"
                      />
                    </DxColumn>

                    <DxColumn
                      data-field="riskAssRole"
                      caption="위험성평가 조직역할"
                      width="150px"
                      data-type="string"
                      alignment="center"
                    >
                      <DxLookup
                        :data-source="riskAssRoleList"
                        value-expr="minorCd"
                        display-expr="minorNm"
                      />
                    </DxColumn>

                    <DxColumn :width="100" cell-template="image" caption="서명" alignment="left" />

                    <DxColumn
                      data-field="hpNo"
                      caption="휴대전화 번호"
                      width="100px"
                      data-type="string"
                      alignment="center"
                    ><DxPatternRule :pattern="pattern" message="휴대전화 번호 형식은 "000-0000-0000" 입니다!" /></DxColumn>

                    <DxColumn
                      data-field="useYn"
                      data-type="boolean"
                      caption="사용"
                      alignment="center"
                      width="70px"
                      edit-cell-template="checkBoxEditor"
                    />

                    <DxColumn
                      data-field="workingAt"
                      caption="입사일"
                      width="100px"
                      data-type="date"
                      alignment="center"
                      format="yyyy.MM.dd"
                    ></DxColumn>

                    <DxColumn
                      data-field="fireAt"
                      caption="퇴사일"
                      width="100px"
                      data-type="date"
                      alignment="center"
                      format="yyyy.MM.dd"
                    ></DxColumn>

                    <DxColumn
                      data-field="remark"
                      caption="비고"
                      width="200px"
                      data-type="string"
                      alignment="left"
                    ></DxColumn>

                    <template #checkBoxEditor="{ data: cellInfo }">
                      <DxCheckBox
                        :value="cellInfo.value == 'Y' ? true : false"
                        :onValueChanged="value => onCheckValueChanged(value, cellInfo)"
                      />
                    </template>
                  </DxDataGrid>
                </v-col>
              </v-col>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxColumn, DxSelection, DxLookup, DxEditing, DxFilterRow, DxPatternRule } from 'devextreme-vue/data-grid'
import DxCheckBox from 'devextreme-vue/check-box'
import { getHrManage, saveHrManage, deleteHrManage } from '@/api/baseManage/esgHRManage'
import { getJasperReportTest } from '@/api/test/jasperReportTest'
import DxContextMenu from 'devextreme-vue/context-menu'

import { getCommonCode } from '@/api/common/commonApi'
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가 및 권한 처리
  components: {
    DxDataGrid,
    DxColumn,
    DxSelection,
    DxCheckBox,
    DxEditing,
    DxFilterRow,
    DxLookup,
    DxPatternRule,
    DxContextMenu
  },
  data() {
    return {
      dxDataGridRef: 'hrDataGrid',
      gridMain: [],
      buttonUseList: [
        'btnSearch', //조회
        'btnPrint' //  출력
      ],
      pattern: /^\d{3}-\d{4}-\d{4}$/i,
      sexDivList: ['남', '여'],
      jbrpList: [],
      riskAssRoleList: [],
      selectRiskAssRoleList: [],
      riskAssRole: '',
      korNm: '',
      delYn: 0,
      compId: null,
      delYnList: [
        { text: '사용', value: '0' },
        { text: '미사용', value: '1' },
        { text: '삭제', value: '2' }
      ],

      isDropZoneActive: false,
      imageSource: '',
      textVisible: true,
      progressValue: 0,
      contextMenuRef: 'contextMenuRef'
    }
  },
  beforeMount() {
    Promise.all([getCommonCode('S0011'), getCommonCode('CM007')]).then(response => {
      let failedResponse = response.find(element => !element.success)
      if (failedResponse == null) {
        //	위험성평가 조직역할 조회조건
        this.selectRiskAssRoleList = response[0].list.slice()
        this.selectRiskAssRoleList.unshift({ minorCd: '', minorNm: '전체' })
        //	위험성평가 조직역할 grid
        this.riskAssRoleList = response[0].list.slice()
        //	직책/직위
        this.jbrpList = response[1].list.slice()
      } else {
        this.$vToastify.error({ body: failedResponse.msg })
      }
    })
  },
  methods: {
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    btnSearch() {
      // this.gridInit()

      this.openLoading('searching')

      let searchParams = { korNm: this.korNm, riskAssRole: this.riskAssRole, compId: this.comp.id, delYn: this.delYn }
      getHrManage(searchParams, true)
        .then(res => {
          if (res.success) {
            this.gridMain = []
            this.gridMain = res.list
            this.GetDataGrid(this.dxDataGridRef).option('focusedRowIndex', 0)
          } else {
            this.$vToastify.error({ body: res.msg })
          }
        })
        .finally(() => {
          this.endLoading()
        })
    },
    btnPrint(type) {
      let searchParams = { korNm: this.korNm, riskAssRole: this.riskAssRole, compId: this.comp.id, delYn: this.delYn }
      let params = {
        esgHRVO: searchParams,
        type: type
      }
      getJasperReportTest(params).then(res => {
        this.downloadReport(res)
      })
    },
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    downloadReport(res) {
      let link = document.createElement('a')
      // 객체를 만들어서 생성
      let objectUrl = window.URL.createObjectURL(res.data)
      link.href = objectUrl
      link.download = res.headers.filename
      link.click()
    }
  }
}
</script>

<style lang="scss">
.dx-command-select {
  width: 30px !important;
  min-width: 30px !important;
}
#dropzone-external {
  width: 85px;
  height: 18px;
  background-color: rgba(183, 183, 183, 0.1);
  border-width: 2px;
  border-style: dashed;
  padding: 0px;
}

#dropzone-external > * {
  pointer-events: none;
}

#dropzone-external.dropzone-active {
  border-style: solid;
}

.widget-container > span {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 16px;
}

#dropzone-image {
  max-width: 100%;
  max-height: 100%;
}

#dropzone-text > span {
  font-weight: 100;
  opacity: 0.5;
}

#upload-progress {
  display: flex;
  margin-top: 20px;
}

.flex-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
}

.widget-container {
  margin-right: 320px;
}

.contents h4 {
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 18px;
}

.contents {
  margin-top: 50px;
  margin-left: 10px;
  display: none;
}

.fileList {
  padding: 10px;
  width: 400px;
  background-color: rgba(183, 183, 183, 0.1);
}

.fileNm {
  height: 20px;
  font-weight: bold;
}

.fileList > .fileSize {
  height: 20px;
  font-size: 12px;
}
</style>
